<script lang="ts">
  import { link } from "svelte-spa-router";
  import { entries } from "../lib/content";
  import { categoryById } from "../lib/categories";

  function fmtDate(s: string): string {
    if (!s) return "";
    const d = new Date(s);
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }

  // Group by `updated` date, newest first.
  $: grouped = (() => {
    const dated = $entries
      .filter((s) => s.updated)
      .sort((a, b) => Date.parse(b.updated) - Date.parse(a.updated));
    const map = new Map<string, typeof dated>();
    for (const s of dated) {
      const key = s.updated;
      const arr = map.get(key) ?? [];
      arr.push(s);
      map.set(key, arr);
    }
    return Array.from(map.entries());
  })();
</script>

<div class="flex flex-col gap-6">
  <div class="flex flex-col gap-2">
    <h1 class="text-3xl font-semibold tracking-tight">Changelog</h1>
    <p class="text-text-muted">What's new and recently updated in the playbook.</p>
  </div>

  {#if grouped.length === 0}
    <div class="panel p-8 text-center text-text-muted">
      Nothing dated yet. Add an <code>updated:</code> field in any SOP frontmatter to populate this.
    </div>
  {:else}
    <ol class="flex flex-col gap-6">
      {#each grouped as [date, sops]}
        <li class="flex flex-col gap-3">
          <div class="text-sm text-text-muted">{fmtDate(date)}</div>
          <ul class="flex flex-col gap-2">
            {#each sops as s}
              {@const cat = categoryById(s.category)}
              <li>
                <a
                  use:link
                  href={`/sop/${s.slug}`}
                  class="panel px-4 py-3 flex items-center justify-between gap-3 hover:border-border-strong transition-colors"
                >
                  <div class="flex-1 min-w-0">
                    <div class="text-sm font-medium text-text truncate">{s.title}</div>
                    {#if s.description}
                      <div class="text-xs text-text-muted truncate">{s.description}</div>
                    {/if}
                  </div>
                  {#if cat}
                    <span class="pill text-text-muted text-[10px]">{cat.label}</span>
                  {/if}
                </a>
              </li>
            {/each}
          </ul>
        </li>
      {/each}
    </ol>
  {/if}
</div>
